export default "__VITE_ASSET__Z4Ak06oJ__"